<template>
  <div class="col-12 px-0 border-bottom pt-3 mb-4 pb-5">
    <h2 class="mb-2">Results</h2>
    <div>
      <div v-if="results.length > 0">
        <form-multi-select
          :options="filteredResults()"
          :value="draft.steps.ephemera.results"
          @input="updateResults"
          display-property="id"
          searchable
          async
          @changed="search => resultsSearch = search"
        >
          <template v-slot:option="{option}">
            {{ date(option) }}:
            {{ option.channel.name }} &mdash;
            {{ option.title }}
          </template>
        </form-multi-select>
      </div>
      <div v-else>
        No results to choose from
      </div>

    </div>
    <div v-if="false">
      <h2 class="mb-2">Events</h2>

      <div class="form-group pt-3 pb-5 mb-4 border-bottom">

        <label>Select events</label>
        <multiselect
          v-model="draft.steps.ephemera.events"
          :options="[]"
          :allow-empty="false"
          :searchable="true"
          :show-labels="false"
          placeholder="Select events"
          track-by="id"
          label="name"
        />
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center border-bottom pt-4 pb-2">
      <h2 class="mb-2">Prioritise key calls</h2>

      <div>
        <ToggleButton
          type="checkbox"
          v-model="draft.steps.ephemera.prioritise"
          :color="{ checked: '#0080a8', unchecked: '#c2c7d9' }"
          class="align-self-center"
        />
      </div>
    </div>

    <div class="form-group pt-3 mb-4">
      <div
        v-for="(key, index) in companiesKeys()"
        :key="key"
        :class="{'mb-5': (index + 1) < draft.steps.ephemera.companies.length }"
        class="pb-5 border-bottom">
        <label>Company {{ index + 1 }}</label>
        <form-select
          v-model="draft.steps.ephemera.companies[index]"
          :options="filteredCompanies()"
          display-property="title"
          placeholder="Search for company"
          @changed="searchCompany"
          @input="company => updateCompany(index, company)"
          async
          searchable
        >
          <template
            v-if="scope.option"
            slot="option"
            slot-scope="scope"
          >
            <span>{{ scope.option.company.shortName }}: {{ scope.option.recommendation.name }} &mdash; {{ scope.option.channel.shortName }}</span>
          </template>
        </form-select>
      </div>
    </div>

    <button class="btn btn-outline-primary mb-5" @click="addCompany">
      + Add key call
    </button>


    <div class="d-flex justify-content-between align-items-center border-bottom border-top py-2">
      <h2 class="mb-0">Show This week’s most read</h2>
      <div>
        <ToggleButton
          type="checkbox"
          v-model="draft.steps.ephemera.showWeekMostRead"
          :color="{ checked: '#0080a8', unchecked: '#c2c7d9' }"
          class="align-self-center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import {debounce} from '@/helpers'
import algolia from '@/algolia'
import gateway from '@/gateway'
import moment from 'moment'
import { FormMultiSelect } from '@frontend/components/src/FormMultiSelect'
import { FormSelect } from '@frontend/components/src/FormSelect'
import { apolloClient } from '../../../../apollo'
import gql from 'graphql-tag'

export default {
  name: 'DailyEquityNoteEphemeraStep',

  components: {
    ToggleButton,
    FormMultiSelect,
    FormSelect,
  },

  data () {
    return {
      recommendations: [],
      results: [],
      resultsSearch: '',
      companyKeyword: '',
    }
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
  },

  beforeMount () {
    this.draft.steps.ephemera = this.draft.steps.ephemera || {results: []}
    this.draft.steps.ephemera.results = this.draft?.steps?.ephemera?.results || []
    this.draft.steps.ephemera.companies = this.draft?.steps?.ephemera?.companies || [{title: ''}]
    this.draft.steps.ephemera.showWeekMostRead = typeof this.draft?.steps?.ephemera?.showWeekMostRead === 'undefined' ? true : this?.draft?.steps?.ephemera?.showWeekMostRead
  },

  async mounted () {
    const r = await gateway.get('cms/companies/recommendations')
    this.recommendations = r.data.data.filter(r => {
      return r.assetClass.id === 1
    })

    const earningsReportId = process.env.NODE_ENV === 'local' ? 13 : 20
    const daysAgo = 7
    const publishStart = new Date()
    publishStart.setHours(publishStart.getHours() - (daysAgo * 24))

    const results = await apolloClient.query({
      query: gql`
        query ($contentTypeIds: [Int!], $publishStart: String!) {
          articles(contentTypeIds: $contentTypeIds, publishStart: $publishStart, page: 1, perPage: 100) {
            value {
              id
              slug
              title
              image
              publishedAt
              summary
              channel {
                name
                badge
              }
              contentType {
                name
              }
              companies {
                name
              }
              leadAnalyst {
                slug
                name
                channel {
                  name
                  slug
                }
                jobTitle
                picture {
                  square
                }
              }
            }
          }
        }
      `,
      variables: {
        contentTypeIds: [earningsReportId],
        publishStart: publishStart.toISOString(),
      },
    })

    this.results = results.data.articles.value
  },

  methods: {
    companiesKeys() {
      return Object.keys(this.draft.steps.ephemera.companies)
    },

    filteredResults () {
      return this.results.filter(result => {
        return `${this.date(result)} ${result.channel?.name} ${result.title}`.toLowerCase().includes(this.resultsSearch.toLowerCase())
      })
    },

    filteredCompanies () {
      return this.recommendations.filter(call => {
        call.title = `${call.company.shortName}: ${call.recommendation.name} ${call.channel.shortName}`
        return `${call.company.shortName}: ${call.recommendation.name} ${call.channel.shortName}`.toLowerCase().includes(this.companyKeyword.toLowerCase())
      })
    },

    updateResults (results) {
      this.draft.steps.ephemera.results = results
      this.$emit('update', { steps: { ephemera: { results } } })
      this.$forceUpdate();
    },

    updateCompany (index, company) {
      this.draft.steps.ephemera.companies[index] = company
      this.$emit('update', { steps: { ephemera: { companies: { [index]: company } } } })
      this.$forceUpdate();
    },

    addCompany() {
      // TODO: is there a limit?
      const index = this.draft.steps.ephemera.companies.length
      this.$emit('update', { steps: { ephemera: { companies: { [index]: {title: ''} } } } })
      this.$forceUpdate();
    },

    date (article) {
      return moment(article.publishedAt).format('D-MMM-YY')
    },

    searchCompany(string) {
      this.companyKeyword = string
    },

    getCompanies: debounce(async function (query) {
      console.log('hello', query)
      const r = await algolia.initIndex('companies').search({query})
      this.companies = r.hits
    }, 200),

  }
}
</script>

<style scoped>
h2 {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
}
</style>
